"use client";

import Link from "@/i18n/i18n-link";
import { Button } from "../ui/button";
import { LightbulbIcon } from "lucide-react";

export default function AnalyticsIcon(props: { userId: string }) {
  return (
    <Button asChild variant={"outline"}>
      <Link
        href={`/analytics/dashboard/${props.userId}`}
        className="flex flex-row gap-2"
      >
        <LightbulbIcon className="h-4 w-4" />
        <code className="italic hidden lg:block">Analytics</code>
      </Link>
    </Button>
  );
}
